import React from 'react';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { CustomButton } from '../../../components';
import { GROUP_USER } from '../../../config/appGroupConfig';
import Row from './Row';

export default function UsersTable({ usersList, canRefund, onRefundClicked }) {
  return (
    <TableContainer component={Paper} style={{ borderRadius: 20 }}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {canRefund && <TableCell />}
            <TableCell align="left">Name</TableCell>
            <TableCell align="left">Email</TableCell>
            <TableCell align="left">Phone number</TableCell>
            <TableCell align="left">Role</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {usersList.map((row, i) => (
            <Row key={row.id} row={row} isCollapsible={canRefund} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

UsersTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  usersList: PropTypes.array.isRequired,
  canRefund: PropTypes.bool.isRequired,
  onRefundClicked: PropTypes.func.isRequired,
};
